import Chart from "react-apexcharts";
import { Box } from "@mui/material";

export const AwarenessChart = ({awarePercent}) => {
   
    const numberOfPagesVisited = parseInt(awarePercent.no_pages_visited)
    const numberofPages = awarePercent.no_total_pages
    const series = [numberOfPagesVisited, (numberofPages-numberOfPagesVisited)]


    const options = {
                chart: {
                    type: 'donut',
                },
                colors:['#DC6600', '#E7E8EA'],
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                    }
                }],
                legend: {
                    show: false
                },
                tooltip: {
                    enabled: false
                },
                dataLabels: {
                    enabled: false
                },
            }

    return (
        <Box sx={{ width: "100%", height: "auto", minWidth: 300 }}>
            <Box id="bar-chart">
                <Chart options={options} series={series} type="donut" height={456}/>
            </Box>
        </Box>
    );
};
